import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material';
import { ReferenceDataService } from 'src/app/Services/AdminConfigurations/reference-data.service';
import { PayerClassService } from 'src/app/Services/AdminConfigurations/payer-class.service';
import { IPayerClass } from 'src/app/models/IPayerClass';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-payer-class-lookup',
  templateUrl: './payer-class-lookup.component.html',
  styleUrls: ['./payer-class-lookup.component.css']
})
export class PayerClassLookupComponent implements OnInit {
  displayedColumns: string[] = ['payerClassCode', 'payerClassName', 'action'];

  allPayerClasses: any[] = [];
  filteredPayerClasses: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  searchTerm: string = '';

  existingPayerClasses: IPayerClass[] = [];
  private existingKeys = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<PayerClassLookupComponent>,
    private referenceDataService: ReferenceDataService,
    private payerClassService: PayerClassService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loadExistingPayerClasses();
    this.loadReferencePayerClasses();
  }

  loadExistingPayerClasses() {
    this.payerClassService.getAllPayerClass().subscribe(data => {
      this.existingPayerClasses = data || [];
      this.buildExistingKeys();
      this.stampFlags();
    });
  }

  loadReferencePayerClasses() {
    this.spinner.show();
    this.referenceDataService.getPayerClasses().subscribe(
      (data) => {
        const raw = Array.isArray(data) ? data : (data as any).data || (data as any).result || [];
        this.allPayerClasses = raw.map(c => this.normalize(c));
        this.filteredPayerClasses = [...this.allPayerClasses];
        this.stampFlags();
        this.dataSource.data = this.filteredPayerClasses;
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        console.error(err);
        this.spinner.hide();
      }
    );
  }

  private normalize(c: any): any {
    return {
      sourceId: c.payerClassId || c.PayerClassId || c.id || c.Id,
      payerClassCode: c.payerClassCode || c.PayerClassCode || c.code || c.Code,
      payerClassName: c.payerClassName || c.PayerClassName || c.name || c.Name,
      isActive: c.isActive != null ? c.isActive : (c.IsActive != null ? c.IsActive : true)
    };
  }

  applySearch() {
    const term = this.searchTerm.trim().toLowerCase();
    if (term) {
      this.filteredPayerClasses = this.allPayerClasses.filter(c =>
        (c.payerClassName && c.payerClassName.toLowerCase().includes(term)) ||
        (c.payerClassCode && c.payerClassCode.toLowerCase().includes(term))
      );
    } else {
      this.filteredPayerClasses = [...this.allPayerClasses];
    }
    this.dataSource.data = this.filteredPayerClasses;
  }

  clearSearch() {
    this.searchTerm = '';
    this.applySearch();
  }

  private getKey(name: string): string {
    return (name || '').toLowerCase();
  }

  private buildExistingKeys(): void {
    this.existingKeys.clear();
    this.existingPayerClasses.forEach(e => this.existingKeys.add(this.getKey(e.payerClassName)));
  }

  private stampFlags(): void {
    this.allPayerClasses.forEach(c => {
      c.isExisting = this.existingKeys.has(this.getKey(c.payerClassName));
    });
  }

  addPayerClass(item: any) {
    this.spinner.show();
    const payerClass = new IPayerClass();
    payerClass.payerClassCode = item.payerClassCode;
    payerClass.payerClassName = item.payerClassName;
    payerClass.isActive = true;
    payerClass.sourceId = item.sourceId;
    (payerClass as any).facilityId = Number(sessionStorage.getItem('FacilityId'));
    (payerClass as any).createdBy = encodeURIComponent(sessionStorage.getItem('userId')).toString();

    this.payerClassService.addPayerClassDetails(payerClass).subscribe(
      (result) => {
        this.toastr.success(result);
        item.isExisting = true;
        this.existingKeys.add(this.getKey(item.payerClassName));
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        this.toastr.error('Failed to add payer class');
        this.spinner.hide();
      }
    );
  }

  close() {
    this.dialogRef.close({ refreshRequired: true });
  }
}
